// extracted by mini-css-extract-plugin
export default {"section":"rOZG0TNNENqKcKMxXEHs"};